import React from 'react';
import { UserState } from '@store/user';
import get from 'lodash.get';
import { UserRole } from '@base/types';

import { SideMenuItem } from './SideMenuItem';
import { ROUTES } from '../constants';
import CreateButton from './CreateButton';

interface Props {
    user?: UserState;
}

const SideMenuMain: React.FC<Props> = ({ user }) => {
    return (
        <>
            <CreateButton />
            {ROUTES.map((route) => (
                <SideMenuItem
                    key={route.title}
                    to={route.to}
                    title={route.title}
                    hasBullet={Boolean(route.hasBullet)}
                    visible={
                        route.visible !== false &&
                        (route.roles ? !!route.roles.find((role) => (get(user, 'role', []) as UserRole[]).includes(role)) : true)
                    }
                />
            ))}
            <div className="menu-item">
                <div className="menu-content">
                    <div className="separator separator-dashed mx-n10" />
                </div>
            </div>
        </>
    );
};

export default SideMenuMain;
